export default __webpack_public_path__ + "static/media/testimonials-01.e0d90c1a.jpg";